import clientConfig from '@v2/config/client'
import style from '@v2/static/client/style'
import platform from '@v2/static/client/platform'
import Vue from 'vue'
import commonUtils from '@v2/static/js/commonUtil.js'

let client = {
  clientSdk: undefined,
  init: function (callback) {
    global.PLATFORMID = platform.getPlatformId()
    global.WEB_HOST_HTTP = clientConfig.httpsHost[global.PLATFORMID]
    global.API_HOST = clientConfig.apiHost[global.PLATFORMID]
    global.LY_API_HOST = clientConfig.lyApiHost[global.PLATFORMID]
    if (platform.isAndroid()) {
      global.APP_HOST = clientConfig.appHost[global.PLATFORMID]
    }
    global.NEW_APP_HOST = clientConfig.newAppHosts[global.PLATFORMID]
    global.NEW_GAME_HOST = clientConfig.newGameHosts[global.PLATFORMID]
    global.NEW_GAME_NO_SCE_HOST = clientConfig.newGameNoSceHosts[global.PLATFORMID]
    global.APP_NAME = clientConfig.appName[global.PLATFORMID]
    global.COIN_NAME = clientConfig.coinName[global.PLATFORMID]
    global.MTA_SID = clientConfig.mtaSid[global.PLATFORMID]
    global.MTA_CID = clientConfig.mtaCid[global.PLATFORMID]
    global.MTA_HID = clientConfig.mtaHid[global.PLATFORMID]
    Vue.prototype.$platform = platform
    style.init()
    this.loadClientJs(callback)
  },
  login: function (callback) {
    if (platform.isQd()) {
      // 起点登录
      client.clientSdk.login(function (result) {
        if (result.result === 0 && result.code === 0) {
          callback()
        }
      })
    } else {
      if (callback) {
        window.loginSuccess = function (ywguid, ywkey) {
          callback(ywguid, ywkey)
        }
      }
      client.clientSdk.loginByQQread(function (result) {
        console.log('测试哈哈哈：')
        let res = JSON.parse(result)
        console.log(res)
        callback(res.data.ywguid, res.data.ywkey)
      })
    }
  },
  qlogin: function (callback) {
    if (global.PLATFORMID === '1') {
      client.clientSdk.qlogin(function () {
        callback()
      })
    } else if (global.PLATFORMID === '2') {
      if (callback) {
        window.loginSuccess = function (ywguid, ywkey) {
          callback(ywguid, ywkey)
        }
      }
      client.clientSdk.loginByQQread()
    } else if (global.PLATFORMID === '3') {
      client.clientSdk.login(function () {
        callback()
      })
    }
  },
  goBack: function () {
    if (global.PLATFORMID === '1') {
      client.clientSdk.goBack()
    } else if (global.PLATFORMID === '2') {
      client.clientSdk.goqqread()
    } else if (global.PLATFORMID === '3') {
      let fabGamePlayNum = commonUtils.getCookie('fabQDGamePlayNum')
      if (fabGamePlayNum !== null && fabGamePlayNum > 0) {
        commonUtils.setCookie('fabQDGamePlayNum', fabGamePlayNum - 1)
        client.clientSdk.exit()
      } else {
        commonUtils.setCookie('fabQDGamePlayNum', 0)
        client.clientSdk.goBack()
      }
    }
  },
  setTitleBarShowState: function (isShowBar, isShowIcon) {
    if (platform.isQq()) {
      isShowBar = isShowBar.toString()
      isShowIcon = isShowIcon.toString()
      client.clientSdk.setBackKeyCallback('')
    }
    client.clientSdk.setTitleBarShowState(isShowBar, isShowIcon)
  },
  getVersion: function (callback, failCallback) {
    if (global.PLATFORMID === '1') {
      client.clientSdk.getVersion(function (version) {
        if (version.data.versionCode >= 341) {
          callback(version)
        } else {
          if (failCallback !== undefined) {
            failCallback(version)
          } else {
            alert('请先升级版本')
          }
        }
      })
    } else if (global.PLATFORMID === '2') {
      client.clientSdk.getvision(function (version) {
        if (version >= 662) {
          callback(version)
        } else {
          if (failCallback !== undefined) {
            failCallback(version)
          } else {
            alert('请先升级版本')
          }
        }
      })
    }
  },
  setBackKeyCallback: function (method) {
    if (global.PLATFORMID === '2') {
      client.clientSdk.setBackKeyCallback(method)
    }
  },
  loadClientJs: function (callback) {
    console.log('sdk加载')
    let jsUrls = clientConfig.clientJsUrls[global.PLATFORMID]
    client.loadJs(jsUrls[0]).then(function () {
      client.loadJs(jsUrls[1]).then(function () {
        client.loadJs(jsUrls[2]).then(function () {
          client.clientSdk = window[clientConfig.sdkName[global.PLATFORMID]]
          callback()
        })
      })
    })
  },
  loadJs: function (url) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script')
      script.src = url
      script.type = 'text/javascript'
      document.body.appendChild(script)

      script.onload = function () {
        console.log(url + '加载完成')
        resolve()
      }

      script.onerror = function () {
        reject()
      }
    })
  }
}

export default client



// WEBPACK FOOTER //
// ./src/v2/static/client/index.js